import * as React from 'react';
import { useParams } from 'react-router-dom';
import { useTheme, useMediaQuery, Grid, Skeleton } from '@mui/material';

import { CerebroText } from '.';
import { useDealQuery } from '../hooks';
import { getYearLabel } from './IncomeStatementRow';

export const IncomeStatementHeadings: React.FC = () => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('md'));

	const { guid: dealGuid } = useParams<'guid'>();

	const dealQuery = useDealQuery(dealGuid);

	if (isMobile) return null;

	const dealCreatedOn = dealQuery.data?.financialStartDate;

	return (
		<Grid container spacing={2} sx={{ marginY: 1 }}>
			<Grid item md={2}></Grid>
			<Grid item md={2}>
				<CerebroText align="center" weight="bold" variant="small">
					{dealQuery.isLoading && <Skeleton height={50} />}
					{dealQuery.isSuccess && getYearLabel('twoYearsAgo', dealCreatedOn)}
				</CerebroText>
			</Grid>
			<Grid item md={2}>
				<CerebroText align="center" weight="bold" variant="small">
					{dealQuery.isLoading && <Skeleton height={50} />}
					{dealQuery.isSuccess && getYearLabel('previousFullYear', dealCreatedOn)}
				</CerebroText>
			</Grid>
			<Grid item md={2}>
				<CerebroText align="center" weight="bold" variant="small">
					{dealQuery.isLoading && <Skeleton height={50} />}
					{dealQuery.isSuccess && getYearLabel('trailingTwelveMonths', dealCreatedOn)}
				</CerebroText>
			</Grid>
			<Grid item md={2}>
				<CerebroText align="center" weight="bold" variant="small">
					{dealQuery.isLoading && <Skeleton height={50} />}
					{dealQuery.isSuccess && getYearLabel('projectedFullYear', dealCreatedOn)}
				</CerebroText>
			</Grid>
			<Grid item md={2}>
				<CerebroText align="center" weight="bold" variant="small">
					{dealQuery.isLoading && <Skeleton height={50} />}
					{dealQuery.isSuccess && getYearLabel('futureYear', dealCreatedOn)}
				</CerebroText>
			</Grid>
		</Grid>
	);
};
